/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useCallback, useContext } from 'react';
import styles from './style.module.scss';
import CatalogueStats from './catalogueStats';
import StatusTabs from './statusTab';
import FiltersComponent from './inventoryFiltersComponent';
import OrderTable from './myInventoryTable';
import {
    fetchBrands, fetchInventory, updateInventory, searchModelId, fetchInventoryRequest, addInventoryRequest, fetchCategory, updatePrices
} from './indexApi';
import AlertComponent from '../../components/AlertComponent/index';
import AddCatalogueComponent from './addCatalogue';
import { debounceFunction } from '../../utils/debounceFunction';
import { Context as AuthContext } from '../../context/AuthContext';
import InventoryRequest from "./inventoryRequestTable";
import RequestFiltersComponent from './requestFilterComponent';

const CataloguePage = () => {
    const { state } = useContext(AuthContext);
    const loginData = state.userData;
    const [status, setStatus] = useState('Inventory');
    const [modelSearch, setModelSearch] = useState();
    const [selectedFilters, setSelectedFilters] = useState({ status: null, category: [], brand: [], requestStatus: [] });
    const [copySelectedFilters, setCopySelectedFilters] = useState({ display_name: null, model: null, status: null, category: [], brand: [], requestStatus: [] });
    const [showFilters, setShowFilters] = useState({ status: false, category: false, brand: false, requestStatus: false });
    const [showEditModal, setShowEditModal] = useState({ quantity: false, price: false });
    const [inventoryData, setInventoryData] = useState([]);
    const [brandData, setBrandData] = useState([]);
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        inactive: 0,
        pending: 0
    });
    const [loader, setLoader] = useState(true);
    const [totalPageCount, setTotalPageCount] = useState(null);
    const [reqObj, setReqObj] = useState({
        sellerId: loginData.seller_id,
        active: null,
        model: null,
        category: [],
        brand: [],
        page: 1,
        size: 15
    })
    const [inventoryReqObj, setInventoryReqObj] = useState({
        sellerId: loginData.seller_id,
        status: null,
        page: 1,
        size: 15
    })
    const [showAlert, setShowAlert] = useState(false);
    const [alertObj, setAlertObj] = useState({
        msg: null,
        color: null
    })
    const [showCatalogueModal, setShowCatalogueModal] = useState(false)
    const [searchedModelId, setSearchedModelId] = useState();
    const [modelArray, setModelArray] = useState([]);
    const [addProductObj, setAddProductObj] = useState({
        display_name: null,
        model: null,
        quantity: null,
        brand: null,
        price: null,
        category: null,
        type: null,
        mrp:null,
        lowest_price: null
    })
    const [totalInventory,setTotalInventory] = useState(0);
    const [showModelDetails, setShowModalDetails] = useState(false);
    const [showAddNewBtn, setShowAddNewBtn] = useState(false);
    const [categoryList,setCategoryList] = useState([]);

    const [selectedRows, setSelectedRows] = useState([]);

    const errorColor = '#f44336';
    const successColor = '#4caf50';

    useEffect(() => {
        if (status === 'Inventory') {
            getBrands();
        }
    }, [reqObj.category]);

    useEffect(() => {
        if (status === 'Inventory') {
            getInventory();
        }
    }, [reqObj])

    useEffect(() => {
        if (status !== 'Inventory') {
            getPendingRequest();
        }
    }, [inventoryReqObj])

    useEffect(()=>{
        getCategories();
    },[])


    const getCategories = async() => {
        await fetchCategory().then((res)=>{
            if(res && res.data && res.data.status) {
                setCategoryList(res.data.data);
            }
        })
    }

    //function to fetch brand filters
    const getBrands = async () => {
        let rObj = {
            category: modifyFilters(reqObj.category)
        };
        let response = await fetchBrands(rObj);
        if (response && response.data && response.data.status === "success") {
            setBrandData(response.data.data);
        }
    }

    //function to fetch inventory data
    const getInventory = async () => {
        setLoader(true);
        let obj = {
            sellerId: reqObj.sellerId,
            active: reqObj.active,
            model: reqObj.model,
            category: modifyFilters(reqObj.category),
            brand: modifyFilters(reqObj.brand),
            page: reqObj.page,
            size: reqObj.size
        }
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        let response = await fetchInventory(obj);
        if (response && response.data && response.data.status === "success") {
            setInventoryData(response.data.data);
            let obj = {
                total: response.data.allCount,
                active: response.data.activeCount,
                inactive: response.data.inactiveCount,
                pending: response.data.pendingCount
            }
            setCopySelectedFilters({ model: reqObj.model, status: reqObj.active, category: JSON.parse(JSON.stringify(reqObj.category)), brand: JSON.parse(JSON.stringify(reqObj.brand)) });
            setTotalPageCount(Math.ceil(response.data.count / reqObj.size));
            setTotalInventory(response.data.count);
            setStats(obj);
            setLoader(false);
        }
        else {
            setAlertFnc('Error while loading. Please try after sometime.', errorColor, true);
            setLoader(false);
        }
    }

    //function to fetch inventory pending request
    const getPendingRequest = async () => {
        setLoader(true);
        let obj = {
            sellerId: inventoryReqObj.sellerId,
            status: inventoryReqObj.status,
            page: inventoryReqObj.page,
            size: inventoryReqObj.size
        }
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        let response = await fetchInventoryRequest(obj);
        if (response && response.data && response.data.status === "success") {
            setInventoryData(response.data.data);
            setCopySelectedFilters({ requestStatus: inventoryReqObj.status });
            setTotalPageCount(Math.ceil(response.data.count / inventoryReqObj.size));
            setTotalInventory(response.data.count);
            setLoader(false);
        } else {
            setAlertFnc('Error while loading. Please try after sometime.', errorColor, true);
            setLoader(false);
        }
    }

    //function to handle tab change
    const handleStatusChange = (value) => {
        if (value === 'Inventory' && status !== 'Inventory') {
            setReqObj({
                sellerId: loginData.seller_id,
                display_name: null,
                active: null,
                model: null,
                category: [],
                brand: [],
                page: 1,
                size: 15
            });
            setSelectedFilters({ status: null, category: [], brand: [] });
        }
        else if (value === 'Pending' && status !== 'Pending') {
            setInventoryReqObj({
                sellerId: loginData.seller_id,
                status: null,
                page: 1,
                size: 15
            });
        }
        setStatus(value);
    }

    //function to handle modelId search
    const handleSearchChange = (e, type) => {
        if (type === 'clear') {
            setModelSearch(undefined);
        }
        else {
            setModelSearch(e.target.value);
        }
    }

    //function to handle filter selection
    const filterChange = (e, type) => {
        let arr = { ...selectedFilters };

        if (type === 'category') {
            if (e.target.checked) {
                arr.category.push(e.target.value);
            }
            else {
                let index = arr.category.findIndex(x => x === e.target.value);
                arr.category.splice(index, 1);
            }
        }
        else if (type === 'status') {
            arr.status = e.target.value ? 1 : 0;
            applyFilter('status', arr.status)
        }
        else if (type === 'brand') {
            if (e.target.checked) {
                arr.brand.push(e.target.value);
            }
            else {
                let index = arr.brand.findIndex(x => x === e.target.value);
                arr.brand.splice(index, 1);
            }
        }
        else if (type === 'requestStatus') {
            arr.requestStatus = e;
            applyInventoryRequestFilter('requestStatus', arr.requestStatus)
        }
        setSelectedFilters(arr);
    }

    //function to cancel filters
    const cancelFilters = (type) => {
        let filters = { ...selectedFilters };
        let hideFilters = { ...showFilters };
        if (type === 'category') {
            filters.category = [...copySelectedFilters.category];
            hideFilters.category = false;
        }
        else if (type === 'status') {
            filters.status = copySelectedFilters.status;
            hideFilters.status = false;
        }
        else if (type === 'brand') {
            filters.brand = [...copySelectedFilters.brand];
            hideFilters.brand = false;
        }
        else if (type === 'requestStatus') {
            filters.requestStatus = copySelectedFilters.requestStatus;
            hideFilters.requestStatus = false;
        }
        setShowFilters(hideFilters)
        setSelectedFilters(filters);
    }

    //function to apply filters
    const applyFilter = async (type, statusVal) => {
        let obj = { ...showFilters };
        let copy = JSON.parse(JSON.stringify(selectedFilters));
        let rObj = { ...reqObj };

        if (type === 'status') {
            obj.status = false;
            rObj.active = statusVal;
        }
        else if (type === 'category') {
            obj.category = false;
            rObj.category = copy.category;
        }
        else if (type === 'brand') {
            obj.brand = false;
            rObj.brand = copy.brand;
        }
        rObj.page = 1;
        setReqObj(rObj)
        setShowFilters(obj);
    }

    //function to apply filters for inventory request
    const applyInventoryRequestFilter = async (type, statusVal) => {
        let obj = { ...showFilters };
        let reqObj = { ...inventoryReqObj };
        if (type === 'requestStatus') {
            obj.requestStatus = false;
            reqObj.status = statusVal;
        }
        reqObj.page = 1;
        setInventoryReqObj(reqObj)
        setShowFilters(obj);
    }

    //function to modify category and brand obj
    const modifyFilters = (obj) => {
        let data;
        if (obj && obj.length > 0) {
            data = `(`;
            obj && obj.length > 0 && obj.map((item, index) => {
                if (index !== obj.length - 1) {
                    data = data + `"${item}",`
                }
                else {
                    data = data + `"${item}")`
                }
                return null;
            })
        }
        return data
    }

    //function to show/hide filters
    const showFiltersFnc = (type) => {
        let obj = {
            status: false,
            category: false,
            brand: false,
            requestStatus: false
        };
        if (type === 'status') {
            obj.status = true;
        }
        else if (type === 'category') {
            obj.category = true;
        }
        else if (type === 'brand') {
            obj.brand = true;
        }
        else if (type === 'requestStatus') {
            obj.requestStatus = true;
        }
        setShowFilters(obj)
    }

    //function to handle filters delete
    const handleDelete = (val, type) => {
        let filters = { ...selectedFilters };
        let copyFilters = { ...copySelectedFilters };
        if (status === 'Inventory') {
            let rObj = { ...reqObj };
            if (type !== 'status' && type !== 'model') {
                let index = filters[type].findIndex(x => x === val);
                filters[type].splice(index, 1);
                copyFilters[type].splice(index, 1);
                rObj[type] = filters[type];
            }
            else if (type === 'model') {
                copyFilters.model = null;
                rObj.model = null;
            }
            else {
                copyFilters['active'] = null;
                filters['active'] = null;
                rObj['active'] = null;
            }
            setReqObj(rObj);
        }
        else {
            let rObj = { ...inventoryReqObj };
            if (type === 'requestStatus') {
                copyFilters['requestStatus'] = null;
                filters['requestStatus'] = null;
                rObj['status'] = null;
                setInventoryReqObj(rObj);
            }
        }
        setSelectedFilters(filters);
    }

    //function to hanlde price/quantity modal close
    const cancelModal = (type) => {
        let modal = { ...showEditModal };
        if (type === 'price') {
            modal.price = false;
        }
        else if (type === 'quantity') {
            modal.quantity = false;
        }
        setShowEditModal(modal)
    }

    //function to show price/quantity modal 
    const showModalFnc = (type) => {
        let obj = {
            price: false,
            quantity: false,
        };
        if (type === 'price') {
            obj.price = true;
        }
        else if (type === 'quantity') {
            obj.quantity = true;
        }
        setShowEditModal(obj)
    }

    //function to edit price,quantity, status
    const updateInventoryFields = async (data, item, type, index) => {
        let requestObj = {
            inventoryId: item.inventoryId,
            role: 'WO_SELLER',
            ...data
        }
        let response = await updateInventory(requestObj);
        if (response && response.data && response.data.status === "success") {
            const newInventoryData = [...inventoryData];
            newInventoryData[index] = {...item, ...data};
            setInventoryData(newInventoryData);
            cancelModal(type);
            let msg;
            if (type === 'price') {
                msg = `Successfully updated price of modal ${item.model}.`;
            }
            else if (type === 'quantity') {
                msg = `Successfully updated quantity of modal ${item.model}.`;
            }
            else {
                setReqObj({ ...reqObj });
                msg = `Successfully ${data.active ? 'activated' : 'deactivated'} modal ${item.model}.`;
            }
            setAlertFnc(msg, successColor, true);

        } else {
            setAlertFnc('Error while updating status. Please try after sometime.', errorColor, true);
        }
    }

    //function to handle items per page
    const setItemsPerPage = (value) => {
        if (status === 'Inventory') {
            let obj = { ...reqObj };
            obj.size = value;
            obj.page = 1;
            setReqObj(obj);
        }
        else {
            let obj = { ...inventoryReqObj };
            obj.size = value;
            obj.page = 1;
            setInventoryReqObj(obj)
        }
    }

    //function to handle pagination
    const handlePageChange = (type) => {
        if (status === 'Inventory') {
            let obj = { ...reqObj };
            if (type === 'Next') {
                obj.page++;
            }
            else {
                obj.page--;
            }
            setReqObj(obj);
        }
        else {
            let obj = { ...inventoryReqObj };
            if (type === 'Next') {
                obj.page++;
            }
            else {
                obj.page--;
            }
            setInventoryReqObj(obj);
        }
    }

    //function to handle stats Tab
    const handleTab = (type) => {
        let rObj = { ...reqObj };
        let invObj = { ...inventoryReqObj };

        if (type === 'all') {
            rObj.active = null;
            rObj.page = 1;
            setStatus('Inventory');
        }
        else if (type === 'active') {
            rObj.active = 1;
            rObj.page = 1;
            setStatus('Inventory');
        }
        else if (type === 'inactive') {
            rObj.active = 0;
            rObj.page = 1;
            setStatus('Inventory');
        }
        else if (type === 'pending') {
            invObj.status = 'WIP';
            invObj.page = 1;
            setStatus('Pending');
        }
        type === 'pending' ? setInventoryReqObj(invObj) : setReqObj(rObj);
    }

    //function to show alerts
    const setAlertFnc = (msg, type, show) => {
        setShowAlert(show);
        setAlertObj({ msg: msg, color: type })
    }

    //function to handle exact model search
    const searchExactModelID = (model) => {
        setReqObj({ ...reqObj, model: model, page:1 });
        setModelSearch('');
    }

    //function to handel autocomplete model search
    const searchModelIdFnc = async (e) => {
        const nextValue = e.target.value;
        console.log(addProductObj);
        setAddProductObj({ ...addProductObj, type: 'exsisting' });
        setSearchedModelId(e.target.value)
        if (e.target.value.length) {
            debounceDropDown(nextValue, getSearchedValues(nextValue));
        }
    }

    //function to fetch autocomplete searched model
    const getSearchedValues = async (nextValue) => {
        setShowModalDetails(false);
        let rObj = {
            model: nextValue,
            sellerId: loginData.seller_id
        };
        let response = await searchModelId(rObj);
        if (response && response.data && response.data.status === "success") {
            console.log(response);
            if (response.data.data.length > 0) {
                setModelArray(response.data.data);
            }
            else {
                setModelArray(response.data.data);
                setShowAddNewBtn(true);
            }
        }
    }

    //function to handle debounce
    const debounceDropDown = useCallback(debounceFunction((nextValue) => getSearchedValues(nextValue), 1000), []);

    //function to handle catalogue request
    const selectedModelFnc = (item, type,obj) => {
        if (type === 'new') {
            setShowModalDetails(true);
            setSearchedModelId('');
            setModelArray(null);
            setAddProductObj({ quantity: null, price: null, category: null, mrp:null, brand: null, display_name: obj?.display_name, model: '', type: 'new', lowest_price: null });
        }
        else if (type === 'exsisting') {
            setSearchedModelId(item);
            setModelArray(null);
            setAddProductObj({ quantity: null, price: null, category: null, brand: null, mrp:obj.mrp, display_name: obj.display_name, model: item, type: 'exsisting', lowest_price: obj.lowest_price });
            setShowModalDetails(true);
            setShowAddNewBtn(false);
        }
    }

    //function to clear autocomplete search result
    const clearSearchResult = () => {
        setSearchedModelId('');
        setModelArray(null);
    }

    //functio to handle add catalogue obj
    const productObj = (e) => {
        setAddProductObj({ ...addProductObj, [e.target.name]: e.target.value })
    }

    //function to send catalogue request
    const addCatalogueRequest = async () => {
        let rObj = {
            status: addProductObj.type === 'new' ? 'WIP' : 'INSTANT_LIVE',
            price: addProductObj.price,
            category: addProductObj.category,
            brand: addProductObj.brand,
            quantity: addProductObj.quantity,
            model: addProductObj.model,
            sellerMobileNo: loginData.username,
            sellerId: loginData.seller_id,
            display_name: addProductObj.display_name
        };
        let response = await addInventoryRequest(rObj);
        if (response && response.data && response.data.status === "success") {
            let msg;
            if (addProductObj.type === 'new') {
                msg = 'Request for catalogue creation has been submitted.'
                setAddProductObj({ display_name: null, model: null, category: null, brand: null, quantity: null, price: null, type: null, mrp: null, lowest_price: null });
            }
            else
                msg = `${addProductObj.model} is made live in your inventory.`

            setAlertFnc(msg, successColor, true);
            clearRequestModal();
            if (rObj.status === 'WIP') { setStats({ ...stats, pending: stats.pending + 1 }); }
            else {
                if (status === 'Inventory') {
                    getInventory();
                }
                else {
                    setStats({ ...stats, total: stats.total + 1 });
                }
            }
        }
        else {
            setAlertFnc(response.data.msg, errorColor, true);
        }
    }

    const clearRequestModal = () => {
        clearSearchResult();
        setShowModalDetails(false);
        setAddProductObj({ display_name: null, model: null, category: null, brand: null, quantity: null, price: null, type: null,mrp:null });
    }

    const selectRow = (row) => {
        const newSelectedRows = [...selectedRows, row];
        setSelectedRows(newSelectedRows);
    }

    const deselectRow = (row) => {
        const newSelectedRows = selectedRows.filter(selectedRow => selectedRow.productId !== row.productId);
        setSelectedRows(newSelectedRows);
    }

    const selectAllRows = (rows) => setSelectedRows(rows);

    const deSelectAllRows = () => setSelectedRows([]);

    const updatePrice = async () => {
        const payload = selectedRows.map(row => ({
            inventoryId: row.inventoryId,
            role: "WO_SELLER",
            price: row.lowest_price,
        }));

        let msg = "";

        try {
            const response = await updatePrices(payload)
            
            if(response?.data?.status === "success") {
                msg = `Prices updated Successfully!`;
                setAlertFnc(msg, successColor, true);

                deSelectAllRows();
                //  Refetch the inventory.
                getInventory();
            } else {
                msg = 'Something went wrong!';
                setAlertFnc(msg, errorColor, true);
            }
        } catch (error) {
            console.log("Error while updating...", error);
            msg = error.msg || 'Something went wrong!';
            setAlertFnc(msg, errorColor, true);
        }
    }


    return <div className={styles.mainContainer}>
        <h5>Inventory Management</h5>
        <AlertComponent color={alertObj.color} msg={alertObj.msg} open={showAlert} handleClose={() => setShowAlert(false)} />
        <CatalogueStats stats={stats} handleTab={handleTab} />
        <StatusTabs status={status} handleStatusChange={handleStatusChange} />
        {status === 'Inventory' ?
            <div>
                <FiltersComponent
                    modelSearch={modelSearch}
                    handleSearchChange={handleSearchChange}
                    searchExactModelID={searchExactModelID}
                    filterChange={filterChange}
                    applyFilter={applyFilter}
                    selectedFilters={selectedFilters}
                    cancelFilters={cancelFilters}
                    showFilters={showFilters}
                    showFiltersFnc={showFiltersFnc}
                    brandData={brandData}
                    categoryList={categoryList}
                    setShowCatalogueModal={() => { clearRequestModal(); setShowCatalogueModal(true); setShowAddNewBtn(false); }}
                    enableUpdatePrice={selectedRows.length > 0}
                    updatePrice={updatePrice}
                />
                <OrderTable
                    handleDelete={handleDelete}
                    copySelectedFilters={copySelectedFilters}
                    showEditModal={showEditModal}
                    cancelModal={cancelModal}
                    showModalFnc={showModalFnc}
                    inventoryData={inventoryData}
                    updateInventoryFields={updateInventoryFields}
                    reqObj={reqObj}
                    totalPageCount={totalPageCount}
                    setItemsPerPage={setItemsPerPage}
                    handlePageChange={handlePageChange}
                    pageLoader={loader}
                    totalInventory = {totalInventory}
                    selectedRows={selectedRows}
                    selectRow={selectRow}
                    deselectRow={deselectRow}
                    selectAllRows={selectAllRows}
                    deSelectAllRows={deSelectAllRows}
                />
            </div>
            :
            <div>
                <RequestFiltersComponent
                    filterChange={filterChange}
                    applyFilter={applyFilter}
                    cancelFilters={cancelFilters}
                    showFilters={showFilters}
                    showFiltersFnc={showFiltersFnc}
                    categoryList={categoryList}
                    setShowCatalogueModal={() => { clearRequestModal(); setShowCatalogueModal(true); setShowAddNewBtn(false); }}
                />
                <InventoryRequest
                    inventoryData={inventoryData}
                    pageLoader={loader}
                    handleDelete={handleDelete}
                    copySelectedFilters={copySelectedFilters}
                    inventoryReqObj={inventoryReqObj}
                    setItemsPerPage={setItemsPerPage}
                    handlePageChange={handlePageChange}
                    totalPageCount={totalPageCount}
                    totalInventory = {totalInventory}
                />
            </div>
        }
        <AddCatalogueComponent
            searchModelIdFnc={searchModelIdFnc}
            searchedModelId={searchedModelId}
            modelArray={modelArray}
            selectedModelFnc={selectedModelFnc}
            clearSearchResult={clearSearchResult}
            addProductObj={addProductObj}
            productObj={productObj}
            showModelDetails={showModelDetails}
            showAddNewBtn={showAddNewBtn}
            show={showCatalogueModal}
            handleClose={() => setShowCatalogueModal(false)}
            addCatalogueRequest={addCatalogueRequest}
        />
    </div>
}

export default CataloguePage;